<template>
  <div>
    <MenuAccount />
    <div class="d-flex justify-space-between mb-2">
      <div class="d-flex justify-center align-center">
        <div class="img_header_sale_report">
          <img src="@/assets/icon-sale-report.png" />
        </div>
        <h2 class="header_sale_report">ดูรายงานทั้งหมด</h2>
      </div>

      <!-- <v-btn color="#038cc1" class="white--text" height="50" width="20%" @click="$router.push('/restaurant')">
            ย้อนกลับ
        </v-btn> -->
    </div>
    <v-slide-x-reverse-transition>
      <v-alert
        type="warning"
        class="alert_success"
        v-if="alert_print_bill_slip === true"
        >กำลังทำการพิมพ์รายงานกรุณารอสักครู่...</v-alert
      >
    </v-slide-x-reverse-transition>
    <div v-if="loading_page === true">
      <v-sheet
        :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
        class="pa-3"
      >
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <div class="d-flex justify-space-between align-center mb-2">
        <div class="startdate_sale_report mr-1">
          <v-menu
            ref="menu_start_date"
            v-model="menu_start_date"
            :close-on-content-click="false"
            :return-value.sync="start_date"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="start_date_be"
                label="วันที่เริ่ม (วัน/เดือน/ปี)"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="start_date"
              :max="end_date"
              no-title
              scrollable
              locale="th"
              :events="dateStartEndBE('start_date')"
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="searchDate('start_date')">
                ตกลง
              </v-btn>
              <v-btn text color="primary" @click="menu_start_date = false">
                ยกเลิก
              </v-btn>
            </v-date-picker>
          </v-menu>
        </div>

        <div class="enddate_sale_report ml-1">
          <v-menu
            ref="menu_end_date"
            v-model="menu_end_date"
            :close-on-content-click="false"
            :return-value.sync="end_date"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="end_date_be"
                label="วันที่สิ้นสุด (วัน/เดือน/ปี)"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="end_date"
              :min="start_date"
              no-title
              scrollable
              locale="th"
              :events="dateStartEndBE('end_date')"
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="searchDate('end_date')">
                ตกลง
              </v-btn>
              <v-btn text color="primary" @click="menu_end_date = false">
                ยกเลิก
              </v-btn>
            </v-date-picker>
          </v-menu>
        </div>
      </div>
      <div class="col-12 d-flex justify-center">
        <v-btn
          color="#1094C7"
          class="white--text titlefont_poslist mx-2"
          type="submit"
          height="50"
          @click="exportPDFSaleReport"
        >
          ดาวน์โหลดรายงาน ไฟล์ PDF
        </v-btn>

        <v-btn
          color="#28ab28"
          class="white--text titlefont_poslist mx-2"
          type="submit"
          height="50"
          @click="exportExcelSaleReport"
        >
          ดาวน์โหลดรายงาน ไฟล์ Excel
        </v-btn>
      </div>
      <!-- <div class="d-flex justify-center mb-3 print_sale_report">
            <v-btn class="grad-primary-bg white--text" width="100%" height="50" @click="printBillSlip()">พิมพ์รายงาน Bill Slip</v-btn>
        </div> -->
      <h3>หน้าร้าน</h3>
      <div class="d-flex mb-3">
        <v-card width="50%" class="mr-1 border_sale_report">
          <div class="pa-3">
            <div>ยอดขาย</div>
            <div class="text-right titlefont_sale_report">
              {{ Intl.NumberFormat().format(total_sale) }}
            </div>
          </div>
        </v-card>
        <v-card width="50%" class="ml-1 border_sale_report">
          <div class="pa-3">
            <div>จำนวนลูกค้า</div>
            <div class="text-right titlefont_sale_report">
              <!-- {{ Intl.NumberFormat().format(total_order) }} -->
              {{ Intl.NumberFormat().format(buff_person) }}
            </div>
          </div>
        </v-card>
      </div>
      <div class="d-flex mb-3">
        <v-card width="50%" class="mr-1">
          <div class="pa-3">
            <div class="d-flex justify-space-between">
              <div>บุฟเฟ่ต์</div>
              <div>{{ Intl.NumberFormat().format(sale_buffet) }}</div>
              <!-- <div>{{ Intl.NumberFormat().format(buff_person) }}</div> -->
            </div>
            <div class="d-flex justify-space-between">
              <div>ไม่บุฟเฟ่ต์</div>
              <div>{{ Intl.NumberFormat().format(sale_notbuffet) }}</div>
            </div>
            <div class="d-flex justify-space-between">
              <div>ซื้อกลับบ้าน</div>
              <div>{{ Intl.NumberFormat().format(sale_takehome) }}</div>
            </div>
            <div class="d-flex justify-space-between">
              <div>อื่นๆ</div>
              <div>{{ Intl.NumberFormat().format(sale_other) }}</div>
            </div>
          </div>
        </v-card>
        <v-card width="50%" class="ml-1">
          <div class="pa-3">
            <div class="d-flex justify-space-between">
              <div>บุฟเฟ่ต์</div>
              <!-- <div>{{ Intl.NumberFormat().format(order_buffet) }}</div> -->
              <div>{{ Intl.NumberFormat().format(buff_person) }}</div>
            </div>
            <div class="d-flex justify-space-between">
              <div>ไม่บุฟเฟ่ต์</div>
              <div>{{ Intl.NumberFormat().format(order_nobuffet) }}</div>
            </div>
            <div class="d-flex justify-space-between">
              <div>ซื้อกลับบ้าน</div>
              <div>{{ Intl.NumberFormat().format(order_takehome) }}</div>
            </div>
          </div>
        </v-card>
      </div>
      <div class="d-flex mb-3">
        <v-card width="30%" class="mr-1">
          <div class="pa-3">
            <div>การรับเงิน</div>
            <v-card class="mb-3 border_sale_report">
              <div class="pa-3">
                <div class="text-center titlefont_sale_report">
                  {{ Intl.NumberFormat().format(pay_in_cash) }}
                </div>
                <div>เงินสด</div>
              </div>
            </v-card>
            <v-card class="mb-3 border_sale_report">
              <div class="pa-3">
                <div class="text-center titlefont_sale_report">
                  {{ Intl.NumberFormat().format(pay_in_cash_transfer) }}
                </div>
                <div>เงินโอน</div>
              </div>
            </v-card>
            <v-card class="mb-3 border_sale_report">
              <div class="pa-3">
                <div class="text-center titlefont_sale_report">
                  {{ Intl.NumberFormat().format(pay_in_cash_credit) }}
                </div>
                <div>เครดิต</div>
              </div>
            </v-card>
            <v-card class="mb-3 border_sale_report">
              <div class="pa-3">
                <div class="text-center titlefont_sale_report">
                  {{ Intl.NumberFormat().format(person_half) }}
                </div>
                <div>โครงการ คนละครึ่ง</div>
              </div>
            </v-card>
            <v-card class="border_sale_report">
              <div class="pa-3">
                <div class="text-center titlefont_sale_report">
                  {{ Intl.NumberFormat().format(blue_flag) }}
                </div>
                <div>โครงการ ร้านธงฟ้า</div>
              </div>
            </v-card>
          </div>
        </v-card>
        <v-card width="70%" class="ml-1">
          <div class="pa-3">
            <canvas id="my-chart"></canvas>
          </div>
        </v-card>
      </div>
      <div class="d-flex mb-3">
        <v-card width="100%">
          <div class="d-flex justify-space-between pa-3">
            <div>สรุปยอดเงินสดในระบบ</div>
            <div>{{ Intl.NumberFormat().format(cash_total) }}</div>
          </div>
        </v-card>
      </div>
      <div class="d-flex mb-3">
        <v-card width="50%" class="mr-1">
          <div class="d-flex justify-space-between pa-3">
            <div>เงินสดเปิดลิ้นชัก</div>
            <div>{{ Intl.NumberFormat().format(money_open) }}</div>
          </div>
        </v-card>
        <v-card width="50%" class="ml-1">
          <div class="d-flex justify-space-between pa-3">
            <div>เงินสดปิดลิ้นชัก</div>
            <div>{{ Intl.NumberFormat().format(money_close) }}</div>
          </div>
        </v-card>
      </div>
      <div class="d-flex mb-3">
        <v-card width="50%" class="mr-1">
          <div class="d-flex justify-space-between pa-3 success--text">
            <div>เงินสดส่วนต่าง +</div>
            <div>{{ Intl.NumberFormat().format(lost_cash_plus) }}</div>
          </div>
        </v-card>
        <v-card width="50%" class="ml-1">
          <div class="d-flex justify-space-between pa-3 error--text">
            <div>เงินสดส่วนต่าง -</div>
            <div>{{ Intl.NumberFormat().format(lost_cash_minus) }}</div>
          </div>
        </v-card>
      </div>
      <div class="d-flex mb-3">
        <v-card width="50%" class="mr-1">
          <div class="pa-3">
            <div class="d-flex justify-space-between align-center">
              <div>จำนวนลูกค้าทานที่ร้าน</div>
              <div class="titlefont_sale_report">
                <!-- {{ Intl.NumberFormat().format(customer_in_restaurant) }} -->
                {{ Intl.NumberFormat().format(buff_person) }}
              </div>
            </div>
          </div>
        </v-card>
        <v-card width="50%" class="ml-1">
          <div class="pa-3">
            <div class="d-flex justify-space-between align-center">
              <div>จำนวนลูกค้าซื้อกลับบ้าน</div>
              <div class="titlefont_sale_report">
                {{ Intl.NumberFormat().format(customer_buy_takehome) }}
              </div>
            </div>
          </div>
        </v-card>
      </div>
      <div class="d-flex mb-3">
        <v-card width="50%" class="mr-1">
          <div class="pa-3">
            <div class="d-flex justify-space-between align-center">
              <div>ยอดขายเฉลี่ยต่อลูกค้า</div>
              <div class="titlefont_sale_report">{{ avg_to_customer }}</div>
            </div>
          </div>
        </v-card>
        <v-card width="50%" class="ml-1">
          <div class="pa-3">
            <div class="d-flex justify-space-between align-center">
              <div>ยอดขายเฉลี่ยต่อออเดอร์</div>
              <div class="titlefont_sale_report">{{ avg_to_order }}</div>
            </div>
          </div>
        </v-card>
      </div>
      <div class="mb-3">
        <v-card>
          <div class="pa-3">
            <h3>เดริเวอร์รี่</h3>
            <v-simple-table>
              <thead>
                <tr>
                  <th class="text-center border_header_sale_report">ชื่อ</th>
                  <th class="text-center border_header_sale_report">
                    ยอดขาย (บาท)
                  </th>
                  <th class="text-center border_header_sale_report">
                    ส่วนลด (บาท)
                  </th>

                  <th class="text-center border_header_sale_report">
                    รายได้ก่อนหักค่าบริการ
                  </th>
                  <th class="text-center border_header_sale_report">
                    ค่าบริการ และ Vat
                  </th>
                  <th class="text-center border_header_sale_report">
                    รายได้สุทธิ
                  </th>
                  <th class="text-center border_header_sale_report">
                    เงินรับเข้า
                  </th>
                  <th class="text-center border_header_sale_report">
                    รายได้ค้างรับ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(delivery_detail, index) in delivery_list"
                  :key="index"
                >
                  <td class="text-center border_header_sale_report">
                    {{ delivery_detail.debtor_name }}
                  </td>
                  <td class="text-center border_header_sale_report">
                    {{ delivery_detail.sale }}
                  </td>
                  <td class="text-center border_header_sale_report">
                    {{ delivery_detail.discount }}
                  </td>
                  <td class="text-center border_header_sale_report">
                    {{ delivery_detail.income_before_deductions }}
                  </td>
                  <td class="text-center border_header_sale_report">
                    {{ delivery_detail.service_vat }}
                  </td>
                  <td class="text-center border_header_sale_report">
                    {{ delivery_detail.total_price }}
                  </td>
                  <td class="text-center border_header_sale_report">
                    {{ delivery_detail.income_price }}
                  </td>
                  <td class="text-center border_header_sale_report">
                    {{ delivery_detail.accrued_income }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTP } from "@/axios.js";
import Chart from "chart.js/auto";
// import 'chartjs-plugin-labels'
import MenuAccount from "@/components/menuadmin/account/accountheader/MenuAccount";
export default {
  name: "saleReport",
  components: { MenuAccount },
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  data() {
    return {
      loading_page: true,
      menu_start_date: false,
      menu_end_date: false,
      start_date_be: "",
      start_date: "",
      end_date_be: "",
      end_date: "",
      alert_print_bill_slip: false,
      cash_total: 0,
      money_open: 0,
      money_close: 0,
      lost_cash_plus: 0,
      lost_cash_minus: 0,
      total_sale: 0,
      sale_buffet: 0,
      sale_notbuffet: 0,
      sale_takehome: 0,
      sale_other: 0,
      total_order: 0,
      order_buffet: 0,
      order_nobuffet: 0,
      order_takehome: 0,
      pay_in_cash: 0,
      pay_in_cash_transfer: 0,
      pay_in_cash_credit: 0,
      person_half: 0,
      blue_flag: 0,
      buff_person: 0,
      customer_in_restaurant: 0,
      customer_buy_takehome: 0,
      avg_to_customer: 0,
      avg_to_order: 0,
      delivery_list: [],
      name_list: [],
      total_price_list: [],
      color_list: [],
      dialogVisible:false
    };
  },
  methods: {
    getRandomColor() {
      let letters = "0123456789ABCDEF";
      let color = "#";
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    async dateDefault() {
      const dateYesterday = new Date().getDate() - 1;
      const dateResult =
        dateYesterday > 9
          ? dateYesterday.toString()
          : `0${dateYesterday.toString()}`;
      const mResult = new Date().getMonth() + 1;
      const monthResult =
        mResult > 9 ? mResult.toString() : `0${mResult.toString()}`;
      this.start_date =
        new Date().getFullYear() + "-" + monthResult + "-" + dateResult;
      this.end_date =
        new Date().getFullYear() + "-" + monthResult + "-" + dateResult;
    },
    dateStartEndBE(type) {
      if (type == "start_date") {
        if (this.start_date == "") {
          this.start_date_be = "";
        }
        if (this.start_date) {
          let date_arr = this.start_date.split("-");
          let year = parseInt(date_arr[0]) + 543;
          let month = parseInt(date_arr[1]) - 1;
          month = this.$store.state.monthList[month].name_short;
          this.start_date_be = `${date_arr[2]}/${month}/${year}`;
        }
      }
      if (type == "end_date") {
        if (this.end_date == "") {
          this.end_date_be = "";
        }
        if (this.end_date) {
          let date_arr = this.end_date.split("-");
          let year = parseInt(date_arr[0]) + 543;
          let month = parseInt(date_arr[1]) - 1;
          month = this.$store.state.monthList[month].name_short;
          this.end_date_be = `${date_arr[2]}/${month}/${year}`;
        }
      }
    },
    async searchDate(type) {
      if (type == "start_date") {
        this.$refs.menu_start_date.save(this.start_date);
        let date_arr = this.start_date.split("-");
        let year = parseInt(date_arr[0]) + 543;
        let month = parseInt(date_arr[1]) - 1;
        month = this.$store.state.monthList[month].name_short;
        this.start_date_be = `${date_arr[2]}/${month}/${year}`;
        this.menu_start_date = false;
      }
      if (type == "end_date") {
        this.$refs.menu_end_date.save(this.end_date);
        let date_arr = this.end_date.split("-");
        let year = parseInt(date_arr[0]) + 543;
        let month = parseInt(date_arr[1]) - 1;
        month = this.$store.state.monthList[month].name_short;
        this.end_date_be = `${date_arr[2]}/${month}/${year}`;
        this.menu_end_date = false;
      }
      if (this.start_date && this.end_date) {
        this.chartAll();
      }
    },
    async chartAll() {
      this.color_list = [];
      this.loading_page = true;
      await HTTP.get(
        "/POS/report/statistics?first_date=" +
          this.start_date +
          "&end_date=" +
          this.end_date,
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.token}`,
          },
        }
      )
        .then((response) => {
          if (response.data.successful === true) {
            this.cash_total = response.data.report.cash_total;
            this.money_open = response.data.report.money_open;
            this.money_close = response.data.report.money_close;
            this.lost_cash_plus = response.data.report.lost_cash_plus;
            this.lost_cash_minus = response.data.report.lost_cash_minus;
            this.total_sale = response.data.report.total_sale;
            this.sale_buffet = response.data.report.sale_buffet;
            this.sale_notbuffet = response.data.report.sale_nobuffet;
            this.sale_takehome = response.data.report.sale_takehome;
            this.sale_other = response.data.report.sale_other;

            this.total_order = response.data.report.total_order;
            this.order_buffet = response.data.report.order_buffet;
            this.order_nobuffet = response.data.report.order_nobuffet;
            this.order_takehome = response.data.report.order_takehome;

            this.pay_in_cash = response.data.report.cash;
            this.pay_in_cash_transfer = response.data.report.cash_transfer;
            this.pay_in_cash_credit = response.data.report.cash_credit;
            this.person_half = response.data.report.person_half;
            this.blue_flag = response.data.report.blue_flag;
            this.buff_person = response.data.report.buff_person;
            this.customer_in_restaurant =
             response.data.report.customer_in_restaurant;
            this.customer_buy_takehome =
              response.data.report.customer_buy_takehome;
            this.avg_to_customer = response.data.report.avg_to_customer;
            this.avg_to_order = response.data.report.avg_to_order;

            this.delivery_list = response.data.delivery;
            this.name_list = response.data.report.arr_name;
            this.total_price_list = response.data.report.arr_price;
            this.total_price_list.forEach(() => {
              this.color_list.push(this.getRandomColor());
            });
            this.loading_page = false;
          }

          if (response.data.successful === false) {
            this.alert_error = true;
          }
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$store.commit("logOutSuccess");
            this.$router.push("/login");
          }
        });

      let ctx = document.getElementById("my-chart");
      new Chart(ctx, {
        type: "bar",
        data: {
          labels: this.name_list,
          datasets: [
            {
              data: this.total_price_list,
              backgroundColor: this.color_list,
            },
          ],
        },
        options: {
          legend: {
            display: false,
          },
          responsive: true,
          maintainAspectRatio: true,
          plugins: {
            labels: {
              render: "value",
              fontColor: ["#000000"],
              precision: 2,
            },
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  max: parseInt(Math.max(...this.total_price_list)) + 1000,
                  beginAtZero: true,
                },
              },
            ],
          },
        },
      });
    },
    async printBillSlip() {
      HTTP.get(
        "/clickprintreport?first_date=" +
          this.start_date +
          "&end_date=" +
          this.end_date,
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.token}`,
          },
        }
      )
        .then((response) => {
          if (response.data.successful === true) {
            this.alert_print_bill_slip = true;
            setTimeout(() => (this.alert_print_bill_slip = false), 5000);
          }

          if (response.data.successful === false) {
            this.alert_error = true;
          }
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$store.commit("logOutSuccess");
            this.$router.push("/login");
          }
        });
    },
    async exportExcelSaleReport() {
      HTTP.post(
        "/POS/export-sale-report-excel",
        { date_start: this.start_date, date_end: this.end_date },
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.token}`,
          },
          responseType: "blob",
        }
      )
        .then((response) => {
          if (response.status == 200) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const downloadLink = document.createElement("a");
            downloadLink.href = url;
            downloadLink.setAttribute("download", "sale_report.xlsx");
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
          }
        })
        .catch((error) => {
          if (error.response.status === 404) {
            this.dialogVisible = true;
          }
          if (error.response.status === 401) {
            this.$store.commit("logOutSuccess");
            this.$router.push("/login");
          }
        });
    },
    async exportPDFSaleReport() {
      HTTP.post(
        "/POS/export-sale-report-pdf",
        { date_start: this.start_date, date_end: this.end_date },
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.token}`,
          },
          responseType: "blob",
        }
      )
        .then((response) => {
          if (response.status == 200) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const downloadLink = document.createElement("a");
            downloadLink.href = url;
            downloadLink.setAttribute("download", "sale_report.pdf");
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
          }
        })
        .catch((error) => {
          if (error.response.status === 404) {
            this.dialogVisible = true;
          }
          if (error.response.status === 401) {
            this.$store.commit("logOutSuccess");
            this.$router.push("/login");
          }
        });
    },
    clearSearch(is_retry) {
      if (is_retry) {
        this.dialogVisible = false;
        this.start_date = "";
        this.end_date = "";
        this.chartAll();
      }
    },
  },
  created() {
    this.dateDefault();
  },
  mounted() {
    this.chartAll();
  },
};
</script>

<style scoped>
.border_header_sale_report {
  border: thin solid rgba(0, 0, 0, 0.12);
}
</style>
